<script setup lang="ts">
import Translator from "@/utils/common/Translator.ts";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import AGGridUtils from "@/utils/UIConstants/AGGridUtils.ts";
import {computed, ref, toValue} from "vue";
import {IToolPanelParams} from "ag-grid-enterprise";

const namaFlagsStore = useNamaFlagsStore();

const props = defineProps<{ params: IToolPanelParams }>()
const showTotalRowCount = computed(() => {
  return namaFlagsStore.getGridOption('showTotalRowCount') !== false;
});
const canShowTotalRowCount = computed(() => props.params.api.getGridOption("rowModelType") !== "serverSide")

const enableCellTextSelection = computed(() => {
  return namaFlagsStore.getGridOption('enableCellTextSelection') !== false;
});

function onCellTextSelectionChanged(value: boolean) {
  namaFlagsStore.updateGridOption('enableCellTextSelection', value);
}

function onTotalRowCountChanged(value: boolean) {
  namaFlagsStore.updateGridOption('showTotalRowCount', value);
}

function getCopyOptions() {
  return Object.values(AGGridUtils.cellCopyMethods).map(o => ({label: Translator.translateId(o), value: o}));
}

function getInitialCopyValue() {
  const stored = localStorage.getItem(AGGridUtils.cellCopyTypeMethod);
  const options = getCopyOptions();
  return options.find(o => o.value === stored) ?? options[0];
}

const cellCopyModel = ref(getInitialCopyValue());

function onCellCopyTypeChanged() {
  localStorage.setItem(AGGridUtils.cellCopyTypeMethod, toValue(cellCopyModel).value);
}
</script>

<template>
  <div class="tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-4 tw-p-3 tw-overflow-y-auto">
    <div class="tw-text-sm tw-font-semibold tw-pb-1 tw-border-b tw-border-gray-200 dark:tw-border-gray-600"
         v-text="Translator.translateId('GridSettings')"/>

    <div class="tw-flex tw-flex-col tw-gap-3">
      <q-toggle
        :model-value="enableCellTextSelection"
        @update:model-value="onCellTextSelectionChanged"
        :label="Translator.translateId('enableCellTextSelection')"
        dense class="tw-text-xs"/>

      <q-toggle
        v-if="canShowTotalRowCount"
        :model-value="showTotalRowCount"
        @update:model-value="onTotalRowCountChanged"
        :label="Translator.translateId('showTotalRowCount')"
        dense class="tw-text-xs"/>
    </div>
    <q-separator/>
    <div class="tw-flex tw-flex-col tw-gap-1">
      <div v-text="Translator.translateId('cellCopyMethod')"
           class="tw-text-xs tw-text-gray-700 dark:tw-text-gray-300"/>
      <q-select
        outlined dense options-dense
        v-model="cellCopyModel"
        @update:model-value="onCellCopyTypeChanged"
        :options="getCopyOptions()"
        popup-content-class="dark:tw-bg-namaBackground-bright-dark"
        class="nama-criteria-field-input nama-customize-list-filter-dense-input"
        input-class="tw-bg-transparent tw-px-0 focus:tw-ring-0 focus:tw-shadow-none focus:tw-border-none dark:tw-text-white dark:tw-placeholder-gray-300"/>
    </div>
  </div>
</template>
